module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/236f257f6b85917b5ba65dc9e4bb75df.png";